import $ from 'jquery';
import loadScript from '../features/loader';
import isTouch from '../exports/touch-detect';

const defaultOptions = {
  autoplay: true,
  loop: true,
  controls: true,
  muted: false,
  playsinline: true,
};

export default function embedVimeo(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const $player = $(`[data-player="${uniqueKey}"]`);
  const $playerElement = $player.find('iframe, [data-replace]');
  const vimeoKey = $player.find('[data-video-id]').attr('data-video-id');
  const loadedPromise = loadScript({url: 'https://player.vimeo.com/api/player.js'});
  const vimeoSelector = `select-${uniqueKey}`;
  $playerElement.attr('id', vimeoSelector);
  const returnPlayer = loadedPromise.then(function() {
    const player = new window.Vimeo.Player(vimeoSelector, {
      ...playerOptions,
      id: vimeoKey,
    });
    $player.on('pause', function() {
      try {
        if (player.pause) {
          player.pause();
        }
      } catch (e) {
        console.warn(e);
      }
    });
    $player.on('play-desktop', function() {
      if (!isTouch()) {
        $player.trigger('play');
      }
    });
    $player.on('play', function() {
      if (player.play) {
        player.play();
      }
    });
    $player.on('destroy', function() {
      try {
        if (player.destroy) {
          player.destroy();
        }
      } catch (e) {
        console.log(e);
      }
    });
    return player;
  }).catch(function(err) {
    console.error(err);
  });
  return returnPlayer;
}
